import { Reveal } from "../components/Reveal";
import { STEPS } from "../data/content";

export default function HowItWorksSection() {
  return (
    <section className="max-w-[1400px] mx-auto px-6 md:px-10 pb-24 md:pb-36">
      <Reveal className="max-w-2xl mb-16 md:mb-24">
        <h2 className="font-display text-4xl md:text-6xl tracking-tighter font-medium leading-[0.98]">
          Live within days,<br />not months.
        </h2>
      </Reveal>
      <div className="divide-y divide-black/10 border-t border-black/10">
        {STEPS.map((step, i) => (
          <Reveal key={step.n} delay={i * 0.05}>
            <div className="group grid md:grid-cols-12 gap-6 py-10 md:py-14 items-start">
              <div className="md:col-span-2 font-display text-5xl md:text-6xl tracking-tighter text-neutral-300 group-hover:text-black transition-colors duration-500">{step.n}</div>
              <h3 className="md:col-span-5 font-display text-2xl md:text-3xl tracking-tight font-medium">{step.title}</h3>
              <p className="md:col-span-5 text-neutral-500 text-lg leading-relaxed">{step.desc}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
